import { getThumbnailImage } from '../../../utils/textHelper';

const textLineHeight = 8;
const barCountToHeight = {
  5: 32,
  4: 39,
  3: 51,
  2: 73,
  1: 127,
};

export function getBarHeight(totalCount) {
  return barCountToHeight[totalCount];
}

export function getTextsHeight(barHeight, textsLine) {
  if (textsLine === 1) {
    return [(barHeight + textLineHeight) / 2];
  }

  return [barHeight / 2 - textLineHeight + 4, barHeight / 2 + textLineHeight + 2];
}

export function getTotalValueByModel(bars) {
  return bars.reduce((acc, bar) => {
    const barData = bar.data;
    const model = barData.data.model;
    if (!acc[model]) {
      acc[model] = 0;
    }
    acc[model] += barData.value;
    return acc;
  }, {});
}

export function getValuesBySalesChannel(bars) {
  return bars.reduce((values, bar) => {
    const {
      color,
      data: { id, value },
    } = bar;

    if (!values[id]) {
      values[id] = {
        total: 0,
        label: id,
        color,
      };
    }
    values[id].total += value;
    return values;
  }, {});
}

export function getDataByModel(bars) {
  return bars.reduce((acc, bar) => {
    const modelData = bar.data.data;
    if (!acc[modelData.model]) {
      acc[modelData.model] = {
        model: modelData.model,
        productName: modelData.productName,
        productImage: getThumbnailImage(modelData.productImage),
      };
    }
    return acc;
  }, {});
}

export function sliceTextWithSvgTitle(text = '', length = 0) {
  if (text.length <= length) return <>{text}</>;

  return (
    <>
      <title>{text}</title>
      {text.slice(0, length)}...
    </>
  );
}
